export default () => ({
    root: {
        position: 'relative',
        width: '100%',
    },
    iconContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginBottom: 8,
    },
});
